import styled, { css } from "styled-components";
import { StyledIcon } from "../decorations/icons/icon.styles";

export const ToggleMenuButton = styled.button<{ isRound?: boolean }>`
    padding: 0;
    border: none;
    border-left: 1px solid ${(props) => props.theme.colors.primaryBorder};
    background: transparent;

    ${(props) => {
        if (props.isRound) {
            return css`
                border: none;
                width: 100%;
                height: 100%;
                background: white;
                border-radius: 50%;
                font-size: 28px;
                display: flex;
                align-items: center;
                justify-content: center;
            `;
        }
    }}
`;

export const List = styled.ul<{
    positionX: number;
    positionY: number;
    renderAboveViewport?: boolean;
}>`
    background: ${(props) => props.theme.colors.cardBackground};
    border-radius: ${(props) => props.theme.borderRadius};
    box-shadow: ${(props) => props.theme.colors.contextMenu.boxShadow};
    display: flex;
    flex-direction: column;
    position: fixed;
    list-style: none;
    right: auto;
    left: ${(props) => props.positionX}px;
    z-index: ${(props) => props.theme.zIndex.max};
    border: 1px solid ${(props) => props.theme.colors.contextMenu.border};

    ${(props) => {
        if (props.renderAboveViewport) {
            return css`
                bottom: ${props.positionY}px;
            `;
        } else {
            return css`
                top: ${props.positionY}px;
            `;
        }
    }}
`;

export const Item = styled.li<{
    deleteOption?: boolean;
    disabled?: boolean;
}>`
    color: ${(props) =>
        props.deleteOption
            ? props.theme.colors.primary
            : props.theme.colors.contextMenuItem.text};
    width: 100%;
    margin-right: 50px;
    border-radius: 3px;
    font-size: 14px;
    white-space: nowrap;
    user-select: none;
    display: flex;

    &:hover {
        background-color: ${(props) =>
            props.disabled
                ? `none`
                : props.theme.colors.contextMenuItem.hoverBackground};
    }

    a {
        line-height: 2;
        padding: 5px 15px;
        text-decoration: none;
        cursor: ${(props) => (props.disabled ? `default` : `pointer`)};
        display: block;
        flex: 1;

        ${(props) => {
            if (props.color) {
                return css`
                    color: ${props.theme.colors.primary};
                `;
            } else {
                return css`
                    color: ${props.deleteOption
                        ? props.theme.colors.primary
                        : props.theme.colors.contextMenuItem.text};
                `;
            }
        }}
    }

    a[disabled] {
        color: ${(props) => props.theme.colors.textDisabled};
    }

    ${StyledIcon} {
        margin-top: ${(props) => props.theme.smallPadding};
        margin-left: ${(props) => props.theme.smallPadding};
    }
`;

export const SectionedItemsContainer = styled.li`
    :not(:first-of-type) {
        border-top: 1px solid
            ${(props) => props.theme.colors.contextMenuItem.border};
    }

    ul {
        list-style-type: none;
    }
`;
